import styled from 'styled-components';

import {
  Button,
  Grid as SemanticGrid,
  Rating as SemanticRating,
} from 'semantic-ui-react';

import {
  Loader as LoaderLayoutComponent,
  Segment as SegmentLayoutComponent, Text as TextLayoutComponent,
} from '@playbookux/playbook-web-core';

const Container = styled.div`
  width: 100%;
  height: 100%;
`;

const VideoContainer = styled.div`
  flex: 1;
`;

const SegmentVideo = styled(SegmentLayoutComponent)`
  &.ui.segment {
    margin-right: 1em;
    min-height: fit-content;
    padding: 18px 30px 18px 30px;
  }
`;

const RightPanel = styled.div`
  background-color: transparent;
  width: 100%;
  padding: 18px 0 0 30px;
  position: absolute;
  bottom: 0;
  top: 0;
  right: 0;
  border: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

const RightPanelContent = styled.div`
  margin-bottom: 40px;
`;

const Message = styled(TextLayoutComponent)`
  margin-bottom: 40px;
  max-width: 600px;
  font-size: 18px;
  text-align: center;
`;

const Navigation = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
`;

const Grid = styled(SemanticGrid)`
  height: 100%;
  &&& {
    margin: 0;
    padding: 0;
  }
`;

const Row = styled(SemanticGrid.Row)`
  &&& {
    margin: 0px;
  }
`;

const Column = styled(SemanticGrid.Column)`
  &&&& {
    padding: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
`;

const Link = styled.a`
  visibility: ${(props) => (!props.visible ? 'hidden' : 'normal')};
`;

const Tester = styled(TextLayoutComponent.Header)`
  display: inline;
  font-size: 18px;
`;

const Loader = styled(LoaderLayoutComponent).attrs(() => ({
  inline: false,
}))``;

const Transcript = styled(TextLayoutComponent)`
  margin-bottom: 15px;
`;

const UrlTypography = styled(TextLayoutComponent)`
  margin-top: 15px;
  margin-bottom: 15px;
  word-break: break-word;

  :first-child {
    margin-top: 15px;
  }
`;

const ContainerMessage = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
`;

const MessageImage = styled.img`
  margin-bottom: 20px;
`;

const CenterContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ContainerBottom = styled.div`
  display: flex;
  justify-content: space-between;
`;

const RatingVideo = styled(SemanticRating).attrs({ cursor: 'pointer' })`
  cursor: pointer;

  &&& i {
    display: flex;
    align-items: center;
  }
`;

const RatingContainer = styled.div`
  padding: 0;
  display: flex;
  align-items: center;
  flex-direction: row;
`;

const ActiveMenu = styled.div`
  flex: 1;
  display: ${(props) => (props?.activeItem === props?.item ? 'flex' : 'none')};
`;

const ButtonContainer = styled.div`
  display: flex;
  padding: 3px;
`;

const NavButton = styled(Button)`
  &&&.ui.labeled.icon.button .icon{
    background: transparent !important;
  }
`;

const InteractionsContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export {
  InteractionsContainer,
  NavButton,
  ActiveMenu,
  ButtonContainer,
  ContainerMessage,
  MessageImage,
  Column,
  Container,
  ContainerBottom,
  CenterContent,
  VideoContainer,
  Grid,
  Link,
  Loader,
  Message,
  Navigation,
  RatingVideo,
  RatingContainer,
  Row,
  RightPanel,
  RightPanelContent,
  SegmentVideo,
  Tester,
  Transcript,
  UrlTypography,
};
